import { defaultTo } from 'aa_common/front-end/helpers'
import moment from 'moment'
import { Dispatch, SetStateAction, useEffect } from 'react'

import {
  getTermMonths,
  resetTermMonths,
  termMonthsInRange,
} from '../components/accelerated-depreciation-drawer/stores/term-months-in-range'
import { AcceleratedDepreciationItem } from '../types'

export const useGetExtraTermMonths = (
  monthlyDepreciation: AcceleratedDepreciationItem[],
  setIsGettingTermMonths: Dispatch<SetStateAction<boolean>>,
  selectedDate?: string
) => {
  const endDateLastMonth = monthlyDepreciation[monthlyDepreciation.length - 1]?.end_date
  const termMonths = defaultTo(
    termMonthsInRange.useSlice(state => state.data),
    []
  )

  useEffect(() => {
    resetTermMonths()
  }, [])

  useEffect(() => {
    setIsGettingTermMonths(false)
  }, [termMonths, setIsGettingTermMonths])

  useEffect(() => {
    if (!selectedDate || !endDateLastMonth || moment(selectedDate).isSameOrBefore(endDateLastMonth)) {
      setIsGettingTermMonths(false)
      return
    }

    setIsGettingTermMonths(true)
    getTermMonths(endDateLastMonth, selectedDate)
  }, [endDateLastMonth, selectedDate, setIsGettingTermMonths])

  return termMonths
}
